'use strict';


export const query = state => state.query;

//=================================================================================================================

export const results = state => state.results;
